// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchPanel_title___G_yd","hint":"SearchPanel_hint__3ynu9","container":"SearchPanel_container__buXcq"};